import Transformer from './Transformer'
import FonctionTransformer from '@/assets/js/dexie/transformers/FonctionTransformer.js'

/**
 * Retourne une liste de
 * @param {Dexie.Collection} season
 */
export default class HorseContactFonctionTransformer extends Transformer {

    async fetch (col) {
        return col.with({
            'fonction'                   : 'horsecontactfonction_fonction',
        })
    }

    async transform (horseContactFonction) {
        return await FonctionTransformer.process(horseContactFonction.fonction)
    }
}
